import { useState, useEffect } from 'react';
import './App.css';
import Login from './components/Login';
import DailyAnnotation from './components/DailyAnnotation';
import UserManagement from './components/UserManagement';
import UserAnalytics from './components/UserAnalytics';
import History from './components/History';
import DataFormation from './components/DataFormation';
import VADAnnotation from './components/VADAnnotation';
import EvalDashboard from './components/EvalResults/EvalDashboard';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [currentPage, setCurrentPage] = useState('daily-annotation');

  useEffect(() => {
    // Additional security measures
    const handleKeyDown = (e) => {
      // Disable additional developer shortcuts
      if ((e.ctrlKey && e.shiftKey && (e.key === 'C' || e.key === 'J')) ||
          (e.ctrlKey && e.key === 'Shift') ||
          e.key === 'F11') {
        e.preventDefault();
      }
    };

    const handleSelectStart = (e) => {
      // Prevent text selection on non-input elements
      if (!['INPUT', 'TEXTAREA'].includes(e.target.tagName)) {
        e.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('selectstart', handleSelectStart);

    // Disable print
    window.addEventListener('beforeprint', (e) => {
      e.preventDefault();
      return false;
    });

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('selectstart', handleSelectStart);
    };
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('companioToken');
    const userData = localStorage.getItem('companioUser');
    if (token && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="app">Loading...</div>;
  }

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
    localStorage.setItem('companioUser', JSON.stringify(userData));
  };

  return (
    <div className="app">
      {!isAuthenticated ? (
        <Login setIsAuthenticated={setIsAuthenticated} onLogin={handleLogin} />
      ) : (
        <>
          {currentPage === 'daily-annotation' && <DailyAnnotation user={user} onPageChange={setCurrentPage} />}
          {currentPage === 'history' && <History user={user} onPageChange={setCurrentPage} />}
          {currentPage === 'users' && user?.is_admin && <UserManagement user={user} onPageChange={setCurrentPage} />}
          {currentPage === 'analytics' && user?.is_admin && <UserAnalytics user={user} onPageChange={setCurrentPage} />}
          {currentPage === 'data-formation' && user?.is_admin && <DataFormation user={user} onPageChange={setCurrentPage} />}
          {currentPage === 'vad-annotation' && <VADAnnotation user={user} onPageChange={setCurrentPage} />}
          {currentPage === 'eval-results' && user?.is_admin && <EvalDashboard user={user} onPageChange={setCurrentPage} />}
        </>
      )}
    </div>
  );
}

export default App;
